import React from 'react';
import './GardenRooms.css';
import GalleryTemplate from "../gallery template/GalleryTemplate";

class GardenRooms extends React.Component {

    componentDidMount() {
    }

    render() {
        return (
            <div className={'page'}>
                <div className={'garden_rooms'}>
                    <h1 className={'pageTitle'}>Bespoke Garden Rooms & Outdoor Joinery</h1>
                    <p className={'pageDescription'}>Extend your living space into the great outdoors with our custom-built garden rooms and outdoor joinery. Whether you envision a versatile entertainment hub, a tranquil office retreat, or unique playhouses and decking, we craft exceptional structures that blend seamlessly with your garden, designed for year-round enjoyment.</p>
                    <GalleryTemplate
                        title={'Bespoke Garden Room with Custom Bar & Entertainment Area'}
                        description={'Create your ultimate outdoor retreat with a custom-built garden room, perfect for entertaining. This versatile space features a stylish wooden exterior, expansive glass doors, and a luxurious interior complete with a bespoke bar, pool table, and ambient lighting, providing year-round enjoyment.'}
                        width={[4]}
                        height={[3]}
                        images={[
                            '/gallery/Garden Rooms/1/20200622_223848_1.jpg',
                            '/gallery/Garden Rooms/1/20200622_224714_1.jpg',
                            '/gallery/Garden Rooms/1/20200622_224216_1.jpg',
                            '/gallery/Garden Rooms/1/20200615_125146_1.jpg',
                        ]}/>
                    <GalleryTemplate
                        title={'Custom Wooden Outdoor Lighting Features'}
                        description={'Add a touch of handcrafted elegance to your outdoor space with these bespoke wooden garden lights, designed to provide subtle illumination and enhance your garden\'s ambiance.'}
                        width={[3,4]}
                        height={[4,3]}
                        images={[
                            '/gallery/Garden Rooms/2/IMG-20200623-WA0006.jpg',
                            '',
                            '/gallery/Garden Rooms/2/20200620_150004_1.jpg',
                            '/gallery/Garden Rooms/2/20200622_224413_1.jpg'
                        ]}/>
                    <GalleryTemplate
                        title={'Custom Built Children\'s Playhouse'}
                        description={'Spark imagination with a bespoke children\'s playhouse, exquisitely crafted with charming details like working windows, flower boxes, and a heart-shaped dormer, providing a delightful outdoor escape for little ones.'}
                        width={[3]}
                        height={[4]}
                        images={[
                            '/gallery/Garden Rooms/3/received_257602362007402.jpeg',
                            '/gallery/Garden Rooms/3/received_729539957589860.jpeg'
                        ]}/>
                    <GalleryTemplate
                        title={'Elegant Hardwood Decking with Balustrade'}
                        description={'Enhance your outdoor living with our premium hardwood decking, custom-built to extend your living space and featuring a classic balustrade for safety and style.'}
                        width={[4]}
                        height={[3]}
                        images={[
                            '/gallery/Garden Rooms/4/2005_0618_182308AA_1.JPG',
                            '/gallery/Garden Rooms/4/2005_0618_182356AA_1.JPG',
                            '/gallery/Garden Rooms/4/2005_0618_182539AA_1.JPG',
                            '/gallery/Garden Rooms/4/2005_0618_182702AA_1.JPG',
                            '/gallery/Garden Rooms/4/2005_0618_182742AA_1.JPG'

                        ]}/>
                    <GalleryTemplate
                        title={'Durable Treated Softwood Decking'}
                        description={'Our robust pressure-treated softwood decking provides a versatile and enduring outdoor living space, complete with sturdy railings, ideal for extending your home\'s usable area into the garden.'}
                        width={[4]}
                        height={[3]}
                        images={[
                            '/gallery/Garden Rooms/5/2001_0121_222433AA.JPG',
                            '/gallery/Garden Rooms/5/2001_0121_222528AA.JPG',
                            '/gallery/Garden Rooms/5/2001_0121_222921AA.JPG'
                        ]}/>
                        <GalleryTemplate
                        title={'Custom-Built Wooden Garden Gazebo'}
                        description={'Create a sheltered outdoor entertainment space with our custom-built wooden gazebo, featuring a robust timber frame and ample room for dining or lounging, perfect for any season.'}
                        width={[4,3]}
                        height={[3,4]}
                        images={[
                            '/gallery/Garden Rooms/6/IMG-20210103-WA0005_1.JPG',
                            '/gallery/Garden Rooms/6/IMG-20210103-WA0002_1.JPG'
                        ]}/>
                </div>
            </div>
        );
    }
}

export default GardenRooms;
